// extracted by mini-css-extract-plugin
export var cartIcon = "_mi-0";
export var cartIconContainer = "_mi-1";